import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 13H3V5h18v11z"
}), 'VideoLabel');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/VideoLabel.js
// module id = 7040
// module chunks = 2